import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CuadroDatos from "../../UI/CuadroDatos.js";
import * as TipoParticipantes from "../../constantes/TipoParticipantesTorneo.js";
import { NombreEquipoTorneo } from "../../funciones/FuncionesEquipo.js";
import useGetListaURL from "../../../hooks/useGetListaURL.js";
import styles from "./CuadroTorneosInt.module.css";

const CuadroTorneosInt = (props) => {
  const organizador = props.organizador;
  const titulo = props.titulo;
  const [listaTorneos, setListaTorneos] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (organizador) {
      fetchData("torneos/ultimos_campeones?oficialidad="+organizador.oficialidad
        +"&tipoParticipacion="+TipoParticipantes.CLUBES
        +"&limiteAnios=4", setListaTorneos);
    } else {
      setListaTorneos([]);
    }
  }, [organizador, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos
        titulo={titulo ? titulo : organizador && organizador.nombre}
        mostrar={true}
        isCargando={isCargando}
        error={erroresGetLista}
      >
        {listaTorneos && listaTorneos.length > 0 && (
          <table className={`${styles.tablaCampeones}`}>
            <tbody>
              <tr className={`${styles.titulos}`}>
                <td className={`${styles.torneo}`}>Torneo</td>
                <td className={`${styles.campeon}`}>Campeón</td>
                <td className={`${styles.subCampeon}`}>Subcampeón</td>
              </tr>
              {listaTorneos.map((torneo, index) => (
                <tr key={index} className={`${styles.filaTorneo}`}>
                  <td className={`${styles.torneo}`}>
                    <Link to={"/torneos/" + torneo.id}>{torneo.descripcion}</Link>
                  </td>
                  <td className={`${styles.campeon}`}>
                      {Array.isArray(torneo.campeones)
                        ? torneo.campeones.map((equipo, i) => (
                            <div key={i}>{NombreEquipoTorneo(equipo, torneo)}</div>
                          ))
                        : NombreEquipoTorneo(torneo.campeones, torneo)}
                  </td>
                  <td className={`${styles.subCampeon}`}>
                      {Array.isArray(torneo.subCampeones)
                        ? torneo.subCampeones.map((equipo, i) => (
                            <div key={i}>{NombreEquipoTorneo(equipo, torneo)}</div>
                          ))
                        : NombreEquipoTorneo(torneo.subCampeones, torneo)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CuadroDatos>
    </div>
  );
};

export default CuadroTorneosInt;